<template lang="pug">
  .login-page
    .login-page-form
      .site-logo
        span.site-name {{ $t('property_list_page.rent_assessment_system') }}
      .data-form
        .data-title
          p {{ $t('login_page.login') }}
        .email-field
          p {{ $t('login_page.account_id') }}
          input(v-model="email" type="email" name="email")
        .password-field
          p {{ $t('login_page.password') }}
          input(v-model="password" type="password" name="password")
        .errors
          p {{ error }}
          button#login-button(@click="signIn") {{ $t('login_page.login') }}
          .actions
            button#forgot-password(
              @click="redirectToForgotPasswordPage"
            ) {{ $t('login_page.if_you_forgot_password') }}
</template>

<script>
  import { api } from '@/api.js'
  import { isEmpty } from 'lodash'
  import redirectLoggedUser from '@/mixins/redirect-logged-user'
  import toastsMixin from '@/mixins/toasts'

  export default {
    mixins: [redirectLoggedUser, toastsMixin],
    
    data() {
      return {
        email: '',
        password: '',
        error: ''
      }
    },

    computed: {
      signInUrl() {
        return '/sessions'
      },

      notEmptyFields() {
        return !isEmpty(this.email) && !isEmpty(this.password)
      }
    },

    mounted() {
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 13) {
          this.signIn()
        }
      })
    },

    methods: {
      signIn() {
        this.errors = ''
        if (this.notEmptyFields) {
          this.sendRequest()
        } else {
          this.error = this.$t('login_page.enter_email_password')
        }
      },

      sendRequest() {
        const params = { email: this.email, password: this.password }
        api.post(this.signInUrl, params)
          .then((resp) => {
            this.setCurrentUser(resp)
            this.redirectToDefaultPage()
          })
          .catch(() => {
            this.error = this.$t('login_page.check_email_or_password')
          })
      },

      setCurrentUser({ data: { auth_token, user: { role } } }) {
        localStorage.setItem('AuthToken', auth_token)
        localStorage.setItem('userRole', role)
      },

      redirectToForgotPasswordPage() {
        this.$router.push({ name: 'ResetPassword' })
        location.reload()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-page {
    background: linear-gradient(270deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
    display: flex;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 3;

    .login-page-form {
      margin: auto;

      .site-logo {
        align-items: center;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        .site-name {
          color: #fff;
          font-size: 18px;
          letter-spacing: 0;
          opacity: 0.9;
        }
      }

      .data-form {
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 4px 16px 0 rgba(176, 186, 197, 0.56);
        padding: 40px;
        width: 395px;

        p {
          color: #7c91a7;
          font-size: 13px;
          letter-spacing: 0;
          margin: 0 0 5px 0;
        }

        .data-title {
          p {
            color: #313541;
            font-size: 20px;
            letter-spacing: 0;
            margin-bottom: 30px;
            opacity: 0.9;
          }
        }

        input {
          background: #fff;
          border: 1px solid #dfe6ee;
          border-radius: 4px;
          height: 40px;
          width: 100%;
        }

        .email-field,
        .password-field {
          margin-bottom: 10%;
        }

        #login-button {
          background-image: linear-gradient(270deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
          border: 0;
          border-radius: 4px;
          color: #fff;
          font-size: 14px;
          height: 40px;
          letter-spacing: 0;
          margin: 20px 0 0 0;
          width: 100%;
        }

        .errors {
          p {
            color: red;
          }
        }

        .actions {
          padding: 20px 0 40px 0;

          #forgot-password {
            background-color: transparent;
            border: 0;
            color: #008bd0;
            float: left;
            font-size: 14px;
            letter-spacing: 0;
          }
        }
      }
    }
  }
</style>
